import axios from "axios";

const productUrl = `${process.env.REACT_APP_BASE_URL}/api/products`;
export const getProducts = async (token, displayError = () => {}) => {
  return await axios
    .get(productUrl, { headers: { authorization: `Bearer ${token}` } })
    .then((response) => {
      return response;
    })
    .catch((error) => {
      if (token) displayError("getProducts error: " + error.message);
    });
};